import React from 'react';
import ConfirmModal from 'js/components/modal/confirm-modal';

export default function TypeWarningModal({ type, onCancel, onConfirm }) {
    return (
        <ConfirmModal
            confirm="Yes, Continue"
            cancel="No, Cancel"
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            <p>
                Changing the context type to {type} will clear all dimension,
                channel and optimization settings for this context.
            </p>
            <p>Are you sure you want to continue?</p>
        </ConfirmModal>
    );
}
